import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

// One-time cleanup of state written by the previous version of the app (Redux persist + auth flag).
try {
  window.localStorage.removeItem('persist:counter');
  window.localStorage.removeItem('isAuthenticated');
} catch (e) {
  /* storage unavailable: nothing to clean */
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
